/* eslint-disable */
import * as THREE from 'three'
import OBJLoader from './OBJLoader/'
import TweenLite from 'gsap/TweenLite'
import { Back } from 'gsap/EasePack'
import EventEmitter from './EventEmitter'

const tunnelVertexShader = require('./shaders/tunnel-1/vertex.glsl')
const tunnelFragmentShader = require('./shaders/tunnel-1/fragment.glsl')

const tokenOutlineVertexShader = require('./shaders/token-outline/vertex.glsl')
const tokenOutlineFragmentShader = require('./shaders/token-outline/fragment.glsl')

export default class Scan extends EventEmitter {
    /**
     * Constructor
     */
    constructor(_options) {
        super()

        this.resources = _options.resources
        this.time = _options.time
        this.sizes = _options.sizes
        this.cursor = _options.cursor
        this.renderer = _options.renderer

        this.renderTarget = new THREE.WebGLRenderTarget(this.sizes.width, this.sizes.height, { minFilter: THREE.NearestFilter, magFilter: THREE.NearestFilter, format: THREE.RGBAFormat })
        this.texture = this.renderTarget.texture
        this.name = 'scan'
        this.hasLevels = true
        this.currentLevel = 1
        this.zoom = 1
        this.zoomOffset = 0
        this.loaded = false
        this.canInteract = false
        this.intersectMeshes = []

        this.setScene()
        this.setModel()

        this.rayCaster = new THREE.Raycaster()
        this.cursorPosition = new THREE.Vector2()
    }

    /**
     * Go to level
     */
    goToLevel(index) {
        
        if (this.tokens) {
            if (index === 1) {
                // Wait before interacting
                this.canInteract = false

                // Tokens
                this.tokens.all.forEach(token => {
                    token.found = false

                    // Hide
                    TweenLite.to(token.material, 0.5, { opacity: 0 })
                    TweenLite.to(token.outlineMaterial.uniforms.uAlpha, 0.5, { value: 0 })
                    TweenLite.to(token.mesh.rotation, 0.5, { y: 0 })
                    TweenLite.to(token.mesh.position, 0.5, { ease: Back.easeOut, y: - 1 + 0.5 })
                    TweenLite.to(token.backGlow.material, 0.5, { ease: Back.easeOut, opacity: 0 })
                    TweenLite.to(token.frontGlow.material, 0.5, { ease: Back.easeOut, opacity: 0 })
                    TweenLite.to(token.uniform.value, 0.5, { ease: Back.easeOut, w: 1 })
                    TweenLite.to(token.mesh.scale, 0.5, { x: 0.03, y: 0.03, z: 0.03, ease: Back.easeOut })
                })

                this.tokens.foundsCount = 0

                this.trigger('prac-found', [this.tokens.foundsCount])

                // Zoom
                TweenLite.to(this, 0.5, { zoomOffset: 0 })

                // Scan alpha
                TweenLite.to(this.model.material.uniforms.uScanAlpha, 0.5, { value: 0, delay: 0.2 })
            } else {
                
                // Wait before interacting
                this.canInteract = false
                window.setTimeout(() => {
                    // Still on level 2
                    if (this.currentLevel === 2) {
                        this.canInteract = true
                    }
                }, 3400)
                
                // Tokens
                this.tokens.all.forEach(token => {
                    token.found = false

                    // Show
                    TweenLite.to(token.material, 0.5, { opacity: 0.8 })
                    TweenLite.to(token.outlineMaterial.uniforms.uAlpha, 0.5, { value: 1 })
                    TweenLite.to(token.mesh.rotation, 0.5, { y: Math.PI * 1 } ) // ???
                    TweenLite.to(token.mesh.position, 0.5, { ease: Back.easeOut, y: - 1 })
                    TweenLite.to(token.backGlow.material, 0.5, { ease: Back.easeOut, opacity: 0.15 }) // 0.15
                    TweenLite.to(token.frontGlow.material, 0.5, { ease: Back.easeOut, opacity: 0.45 }) // 0.45
                    TweenLite.to(token.uniform.value, 0.5, { ease: Back.easeOut, w: 0 })
                    TweenLite.to(token.mesh.scale, 0.5, { x: 0.028, y: 0.028, z: 0.028, ease: Back.easeOut })
                })

                // Zoom
                TweenLite.to(this, 0.5, { zoomOffset: 0.1 })

                // Scan alpha
                TweenLite.to(this.model.material.uniforms.uScanAlpha, 0.5, { value: 1, delay: 0.2 })
            }
        }

        this.currentLevel = index
    }

    /**
     * Set scene
     */
    setScene() {
        // Scene
        this.scene = new THREE.Scene()

        // Camera
        this.camera = new THREE.PerspectiveCamera(40, this.sizes.width / this.sizes.height, 0.1, 1000)
        this.camera.originalRotation = new THREE.Vector3()
        this.camera.originalPosition = new THREE.Vector3()
        this.camera.rotation.order = 'YXZ'

        window.camera = this.camera

        this.mouse = {}
        this.mouse.x = 0.5
        this.mouse.y = 0.5

        this.cursor3d = new THREE.Vector3()

        // // Dummy
        // this.dummy = new THREE.Mesh(new THREE.BoxGeometry(0.1, 0.1, 0.1), new THREE.MeshBasicMaterial({ color: 0xff0000 }))
        // this.scene.add(this.dummy)
    }

    /**
     * Set model
     */
    setModel() {
        this.model = {}

        // Load and set token
        const objLoader = new OBJLoader()
        objLoader.load('/static/3d/token.obj', data => {
            this.setTokens(data)

            // Load and set tunel
            const objectLoader = new THREE.ObjectLoader()
            objectLoader.load('/static/3d/tunnel-test-1-data.json', data => {
                this.setTunel(data)
                this.loaded = true
                this.resize()
            })
        })
    }

    /**
     * Set tokens
     */
    setTokens(data) {
        this.tokens = {}
        this.tokens.foundsCount = 0
        this.tokens.coordinates = [
            [6, 1.5, 9], // floor right
            [16, 1.5, 18], // floor center 1
            [13, 1.5, 36], // floor center 2
            [18, 1.5, 4], // floor left
            [2, 4, 34], // wall right
            [26.5, 4, 8], // poll left 1
            [26.5, 4, 26], // poll left 2
            [22.5, 11, 10], // roof left 1
            [22.5, 11, 30], // roof left 2
            [12, 11, 18], // roof middle 2
            [2, 8, 18], // roof right 1
            [4, 11, 32], // roof right 2
        ]
        this.tokens.all = []

        // Token geometry
        const tokenGeometry = data.children[0].geometry

        // Glow geometry
        const glowGeometry = new THREE.PlaneGeometry(5, 5, 1, 1)
        const glowTexture = new THREE.TextureLoader().load('/static/3d/token-glow.png')

        // Each token
        for (const coordinate of this.tokens.coordinates) {
            // Step up
            const token = {}
            token.found = false

            // Random value
            token.random = Math.random()

            // Container
            token.container = new THREE.Object3D()
            token.container.position.x = coordinate[0]
            token.container.position.y = coordinate[1]
            token.container.position.z = coordinate[2]
            this.scene.add(token.container)

            // Container
            token.inner = new THREE.Object3D()
            token.container.add(token.inner)

            // Token material
            token.material = new THREE.MeshBasicMaterial({
                color: 0xffffff, // 0x004970
                depthTest: true,
                depthWrite: false,
                opacity: 1,
                transparent: true
            })

            // Token mesh
            token.mesh = new THREE.Mesh(tokenGeometry, token.material)
            token.mesh.renderOrder = 102
            token.mesh.scale.x = 0.03
            token.mesh.scale.y = 0.03
            token.mesh.scale.z = 0.03
            token.mesh.position.y = - 1
            token.mesh.rotation.y = Math.PI
            token.inner.add(token.mesh)

            // Token outline material
            // token.outlineMaterial = new THREE.MeshBasicMaterial({
            //     color: 0xff0000,
            //     depthTest: true,
            //     depthWrite: false,
            //     opacity: 1,
            //     transparent: true,
            //     side: THREE.BackSide
            // })
            token.outlineMaterial = new THREE.ShaderMaterial({
                uniforms:
                {
                    uColor: { value: new THREE.Color(0xd2fcff) },
                    uStrength: { value: 0.02 },
                    uAlpha: { value: 0 }
                },
                vertexShader: tokenOutlineVertexShader,
                fragmentShader: tokenOutlineFragmentShader,
                blending: THREE.AdditiveBlending,
                depthTest: true,
                depthWrite: false,
                transparent: true,
                side: THREE.BackSide
            })

            // Token mesh outline
            token.outlineMesh = new THREE.Mesh(tokenGeometry, token.outlineMaterial)
            token.outlineMesh.renderOrder = 101
            token.outlineMesh.scale.x = 1
            token.outlineMesh.scale.y = 1
            token.outlineMesh.scale.z = 1
            // token.mesh.add(token.outlineMesh)

            // back glow
            token.backGlow = new THREE.Mesh(glowGeometry, new THREE.MeshBasicMaterial({
                color: new THREE.Color(0xffffff),
                map: glowTexture,
                transparent: true,
                opacity: 0.15,
                depthTest: true,
                depthWrite: false,
                // blending: THREE.AdditiveBlending
            }))
            token.backGlow.scale.x = 1
            token.backGlow.scale.z = 1
            token.backGlow.scale.y = 1
            token.backGlow.rotation.y = Math.PI
            token.backGlow.position.x = 0
            token.backGlow.position.y = -0.4
            token.backGlow.position.z = 0
            token.backGlow.renderOrder = 100
            token.inner.add(token.backGlow)

            // front glow
            token.frontGlow = new THREE.Mesh(glowGeometry, new THREE.MeshBasicMaterial({
                color: new THREE.Color(0xffffff), // 0x85f6ff
                map: glowTexture,
                transparent: true,
                opacity: 0.3,
                depthTest: true,
                depthWrite: false,
                // blending: THREE.AdditiveBlending
            }))
            token.frontGlow.scale.x = 0.6
            token.frontGlow.scale.z = 0.6
            token.frontGlow.scale.y = 0.6
            token.frontGlow.rotation.y = Math.PI
            token.frontGlow.position.x = 0
            token.frontGlow.position.y = -0.4
            token.frontGlow.position.z = 0
            token.frontGlow.renderOrder = 103
            token.inner.add(token.frontGlow)
            
            // Intersection
            token.intersection = new THREE.Mesh(glowGeometry, new THREE.MeshBasicMaterial({
                color: new THREE.Color(0xff0000),
                transparent: true,
                wireframe: true,
                depthTest: false,
                depthWrite: false
            }))
            token.intersection.scale.x = 0.25
            token.intersection.scale.z = 0.25
            token.intersection.scale.y = 0.25
            token.intersection.rotation.y = Math.PI
            token.intersection.position.x = 0
            token.intersection.position.y = -0.4
            token.intersection.position.z = 0
            token.intersection.renderOrder = 0
            token.inner.add(token.intersection)
            this.intersectMeshes.push(token.intersection)

            // Uniform
            token.uniform = { type: 'v4', value: new THREE.Vector4(coordinate[0], coordinate[1], coordinate[2], 0) }

            // // Dummy
            // token.dummy = new THREE.Mesh(new THREE.BoxGeometry(0.25, 0.25, 0.25), new THREE.MeshBasicMaterial({ color: 0xff0000 }))
            // token.container.add(token.dummy)

            // Save
            this.tokens.all.push(token)
        }
    }

    /**
     * Set tunel
     */
    setTunel(data) {
        // Model
        this.model.uniforms = {
            uTextureAlpha: { type: 't', value: this.resources.items.tunnelAlphaTexture },
            uTextureDefault: { type: 't', value: this.resources.items.tunnelDefaultTexture },
            uTextureScanned: { type: 't', value: this.resources.items.tunnelScannedTexture },
            uTime: { type: 'f', value: 0 },
            uCursorPosition: { type: 'v3', value: new THREE.Vector3() },
            uScanAlpha: { type: 'f', value: 0 }
        }

        this.model.vertexShader = tunnelVertexShader

        // Replace parts of the fragment with token uniforms
        this.tokens.all.forEach((token, index) => {
            const name = `uScanPoint${index}`
            this.model.uniforms[name] = token.uniform
        })

        this.model.fragmentShader = tunnelFragmentShader.replace('[scanpoint-fragment-0]', () =>
        {
            let replacement = ''
            this.tokens.all.forEach((token, index) => {
                const name = `uScanPoint${index}`

                replacement += `
                    uniform vec4 ${name};
                `
            })
            return replacement
        })

        this.model.fragmentShader = this.model.fragmentShader.replace('[scanpoint-fragment-1]', () =>
        {
            let replacement = ''
            this.tokens.all.forEach((token, index) => {
                const name = `uScanPoint${index}`

                replacement += `
                    scanAlpha += (1.0 - clamp(distance(vPosition, ${name}.xyz) / 7.5 - 0.75, 0.0, 1.0)) * ${name}.a;
                `
            })
            return replacement
        })

        // this.model.material = new THREE.MeshBasicMaterial({
        //     color: new THREE.Color(0xff0000),
        //     wireframe: false,
        //     side: THREE.FrontSide
        // })
        this.model.material = new THREE.ShaderMaterial({
            depthTest: true,
            depthWrite: false,
            transparent: true,
            uniforms: this.model.uniforms,
            vertexShader: this.model.vertexShader,
            fragmentShader: this.model.fragmentShader
        })
        
        // Meshes
        this.model.meshes = []

        // Scene
        const meshOptions = {
            background: {
                renderOrder: 1
            },
            'ceiling-1': {
                renderOrder: 10
            },
            'ceiling-2': {
                renderOrder: 10
            },
            'ceiling-3': {
                renderOrder: 10
            },
            floor: {
                renderOrder: 3
            },
            men: {
                renderOrder: 10
            },
            roof: {
                renderOrder: 4
            },
            center: {
                renderOrder: 11
            }
        }
        const meshOptionsKeys = Object.keys(meshOptions)

        // Each object
        for (const object of data.children) {
            // Meshes
            if (object instanceof THREE.Mesh) {
                if (meshOptionsKeys.indexOf(object.name) !== -1) {
                    const meshOption = meshOptions[object.name]

                    // Change material
                    object.material = this.model.material
                    object.renderOrder = meshOption.renderOrder

                    // Save
                    this.model.meshes.push(object)
                    this.intersectMeshes.push(object)
                }
            }

            // Camera
            if (object instanceof THREE.Camera) {
                this.camera.fov = object.fov
                this.camera.position.copy(object.position)
                this.camera.rotation.copy(object.rotation)
                this.camera.originalPosition.copy(object.position)
                this.camera.originalRotation.copy(object.rotation)
            }
        }

        for (let i = 0; i < this.model.meshes.length; i++) {
            const mesh = this.model.meshes[i]
            this.scene.add(mesh)
        }
    }

    /**
     * Resize
     */
    resize() {
        const sceneRatio = 3 / 2
        const viewportRatio = this.sizes.width / this.sizes.height

        if (sceneRatio < viewportRatio) {
            this.zoom = viewportRatio / sceneRatio
        } else {
            this.zoom = 1
        }

        // Camera
        this.camera.aspect = this.sizes.width / this.sizes.height

        // Render target
        this.renderTarget.setSize(this.sizes.width, this.sizes.height)
    }

    /**
     * Update
     */
    update() {
        if(!this.loaded) {
            return
        }

        this.cursorPosition.x = this.cursor.fromCenter.x * 2
        this.cursorPosition.y = -this.cursor.fromCenter.y * 2
        this.rayCaster.setFromCamera(this.cursorPosition, this.camera)

        const intersects = this.rayCaster.intersectObjects(this.intersectMeshes, true)

        if (intersects.length > 0) {
            // this.dummy.position.copy(intersects[0].point)
            this.cursor3d.copy(intersects[0].point)
        }

        this.model.material.uniforms.uTime.value = this.time.elapsed

        this.model.material.uniforms.uCursorPosition.value.x += (this.cursor3d.x - this.model.material.uniforms.uCursorPosition.value.x) * 0.005 * this.time.delta
        this.model.material.uniforms.uCursorPosition.value.y += (this.cursor3d.y - this.model.material.uniforms.uCursorPosition.value.y) * 0.005 * this.time.delta
        this.model.material.uniforms.uCursorPosition.value.z += (this.cursor3d.z - this.model.material.uniforms.uCursorPosition.value.z) * 0.005 * this.time.delta

        this.camera.zoom = this.zoom + this.zoomOffset
        this.camera.updateProjectionMatrix()

        this.camera.position.copy(this.camera.originalPosition)
        this.camera.rotation.copy(this.camera.originalRotation)

        this.mouse.x += (this.cursor.fromCenter.x - this.mouse.x) * 0.005 * this.time.delta
        this.mouse.y += (this.cursor.fromCenter.y - this.mouse.y) * 0.005 * this.time.delta

        this.camera.position.z += 0.5
        this.camera.position.y += this.mouse.y * 0.3
        this.camera.position.x -= this.mouse.x * 0.3

        // Tokens
        this.tokens.all.forEach(token => {
            // Permanent movement
            token.inner.position.y = Math.sin(this.time.elapsed * 0.0005 + token.random * Math.PI * 2) * 0.35

            if (this.currentLevel === 2 && this.canInteract) {
                // Token not yet found
                if (!token.found) {
                    // Token close enough from cursor
                    const distance = token.container.position.distanceTo(this.cursor3d)

                    if (distance < 5) {
                        token.found = true
                        this.tokens.foundsCount++

                        // Hide
                        TweenLite.to(token.material, 0.5, { opacity: 0 })
                        TweenLite.to(token.outlineMaterial.uniforms.uAlpha, 0.5, { value: 0 })
                        TweenLite.to(token.mesh.rotation, 0.5, { y: Math.PI * 2 })
                        TweenLite.to(token.mesh.position, 0.5, { ease: Back.easeOut, y: - 1 + 0.5 })
                        TweenLite.to(token.backGlow.material, 0.5, { ease: Back.easeOut, opacity: 0 })
                        TweenLite.to(token.frontGlow.material, 0.5, { ease: Back.easeOut, opacity: 0 })
                        TweenLite.to(token.uniform.value, 0.5, { ease: Back.easeOut, w: 1 })
                        TweenLite.to(token.mesh.scale, 0.5, { x: 0.03, y: 0.03, z: 0.03, ease: Back.easeOut })

                        // Trigger
                        this.trigger('prac-found', [this.tokens.foundsCount])
                    }
                }
            }
        })

        // Render
        this.render()
    }

    /**
     * Render
     */
    render() {
        this.renderer.render(this.scene, this.camera, this.renderTarget)
    }

    /**
     * Dispose
     */
    dispose() {
        for (let i = 0; i < this.model.meshes.length; i++) {
            const mesh = this.model.meshes[i]

            mesh.geometry.dispose()
        }

        this.texture.dispose()
    }
}



// WEBPACK FOOTER //
// ./src/scripts/libs/experience/Scan.js